export default "__VITE_ASSET__CiRHgWyo__"